export const getImageSuffix = (controller) => controller.blueprint.custom['t-master-product'].replace(/:/g, '-');

export default function getImage(controller, option, { includeProductSuffix = true } = {}) {
    const custom = option?.custom || option?.raw?.custom;
    if (!custom) {
        return '';
    }

    const image = custom?.['v-image'];

    if (image) {
        return `https://media.titleist.com/images/vokey/WedgeWorks-Flight-Lines/${image}`;
    }

    const thumbnailAsset = custom?.['v-thumbnail-asset'];

    if (thumbnailAsset) {
        const baseUrl = controller.blueprint.imageRootUrl;
        const suffix = includeProductSuffix ? `-${getImageSuffix(controller)}` : '';
        return `${baseUrl}${thumbnailAsset}${suffix}?fmt=webp`;
    }

    const thumbnail = custom?.['v-thumbnail'];
    if (thumbnail) {
        if (thumbnail.startsWith('http')) {
            // Thumbnails probably from SFCC.
            return thumbnail;
        }
        return `https://acushnet.scene7.com/is/image/vokey/${thumbnail}?scl=1`;
    }

    const thumbnailImage = custom?.['v-thumbnail-image'];
    if (thumbnailImage) {
        return thumbnailImage;
    }

    return '';
}
